<!-- 新闻详情 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_news.png"
      class="banner"
    />
    <div class="wrap">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="container w1200">
        <div class="content">
          <div class="title-box">
            <div class="title">{{ detail.title }}</div>
            <div class="time">
              发布时间：{{
                detail.publishTime || detail.createTime | handleTime
              }}
            </div>
          </div>
          <div class="rich" v-html="detail.contentStr"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
export default {
  data() {
    return {
      detail: {},
      subNavs: [],
      routerHistory: [],
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  components: { breadCrumb, SubNav },
  created() {
    this.getDetail();
  },
  mounted() {},
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find((ele) => {
        const firstPath = this.$route.path.split("/")[1];
        return ele.path != "/" && "/" + firstPath == ele.path;
      });
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [
        { path: "/", name: "首页" },
        { path: "/news/company", name: "资讯动态" },
        { name: this.detail.title },
      ];
    },
    async getDetail() {
      let res = await this.$api.getNewInfo(this.$route.params.id);
      if (!res.data) {
        this.$notify.warning({ title: "当前内容已不存在" });
      }
      this.detail = res.data;
      this.formatBreadCrumb();
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    height: 600px;
    object-fit: cover;
  }
  .wrap {
    background-image: url("http://api.zyzxgc.cn/file/static/news_bg.png");
    background-size: cover;
    background-position-x: center;

    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 30px auto 120px;

    .post {
      width: 100%;
      margin-bottom: 120px;
    }
  }
  .content {
    .title-box {
      text-align: center;
      padding: 30px 20px 5px;
      line-height: 40px;
      border-bottom: 1px solid #dedede;

      .title {
        font-size: 30px;
      }
      .time {
        font-size: 14px;
        color: #999;
      }
    }
    .rich {
      min-height: 400px;
      padding: 20px;
    }
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;
    }
    .content {
      margin: 30px 0;

      .title-box {
        padding: 10px 0;

        .title {
          font-size: 25px;
        }
      }
      .rich {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
        overflow: auto;
      }
    }
  }
}
</style>
